import { FormEvent, useState } from "react";
import { MessageSquareText } from "lucide-react";
import { request } from "./FunctionalApp";
export function FeedbackWorkspace() {
  const [category, setCategory] = useState("PROBLEM"),
    [message, setMessage] = useState(""),
    [status, setStatus] = useState("");
  async function submit(e: FormEvent) {
    e.preventDefault();
    setStatus("Sending…");
    const response = await request("/api/feedback", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ category, message, page: location.pathname }),
    });
    if (response.ok) {
      setMessage("");
      setStatus("Thank you — your feedback has been sent to TaskRoute staff.");
    } else {
      const body = await response.json().catch(() => ({}));
      setStatus(
        String(body.error || "Unable to send feedback").replaceAll("_", " "),
      );
    }
  }
  return (
    <>
      <div className="func-heading">
        <div>
          <h1>Test feedback</h1>
          <p>
            Tell us what failed, felt confusing or would make maintenance work
            easier.
          </p>
        </div>
      </div>
      <section className="func-panel simple-form">
        <h2>
          <MessageSquareText /> Send feedback
        </h2>
        <form onSubmit={submit}>
          <label>
            Type
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="PROBLEM">Something did not work</option>
              <option value="CONFUSING">Something was confusing</option>
              <option value="SUGGESTION">Feature suggestion</option>
              <option value="OTHER">Other feedback</option>
            </select>
          </label>
          <label className="wide">
            What happened or what should change?
            <textarea
              required
              minLength={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Please include what you were trying to do and what you expected to happen."
            />
          </label>
          <button>Send feedback</button>
          {status ? <p>{status}</p> : null}
        </form>
      </section>
    </>
  );
}
